import React from 'react';
import { motion } from 'framer-motion';

interface PageBannerProps {
  title: string;
  subtitle?: string;
  imageSrc: string;
  overlay?: boolean;
}

const PageBanner = ({ title, subtitle, imageSrc, overlay = true }: PageBannerProps) => {
  return (
    <div className="relative h-80 md:h-96 bg-gray-900 overflow-hidden">
      <img
        src={imageSrc}
        alt={title}
        className="absolute inset-0 w-full h-full object-cover"
      />

      {overlay && (
        <div className="absolute inset-0 bg-black/50 backdrop-blur-[1px]"></div>
      )}

      <div className="container mx-auto px-4 h-full relative z-10">
        <div className="flex flex-col justify-center h-full max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {subtitle && (
              <span className="inline-block text-primary font-medium mb-2">
                {subtitle}
              </span>
            )}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              {title}
            </h1>

            <motion.div
              className="w-20 h-1 bg-primary rounded"
              initial={{ width: 0 }}
              animate={{ width: 80 }}
              transition={{ duration: 0.8, delay: 0.5 }}
            />
          </motion.div>
        </div>
      </div>

      {/* Curved bottom edge */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0L48 5.42C96 10.85 192 21.7 288 24.13C384 26.57 480 20.57 576 17.13C672 13.7 768 12.85 864 16.28C960 19.72 1056 27.43 1152 28.27C1248 29.12 1344 23.28 1392 20.37L1440 17.45V40H1392C1344 40 1248 40 1152 40C1056 40 960 40 864 40C768 40 672 40 576 40C480 40 384 40 288 40C192 40 96 40 48 40H0V0Z" fill="white" />
        </svg>
      </div>
    </div>
  );
};

export default PageBanner;
